import { useI18n } from 'iomart-hooks';
// components
import { useSettingsContext } from '../components/settings';
//
import { allLangs, defaultLang } from './config-lang';

// ----------------------------------------------------------------------

export default function useLocales() {
  const i18n = useI18n();
  const { currentLang: currentLangCode } = i18n;
  const { onChangeDirectionByLang } = useSettingsContext();

  const currentLang = allLangs.find((lang) => lang.value === currentLangCode) || defaultLang;

  const handleChangeLanguage = (newLang: string) => {
    i18n.setCurrentLang(newLang);
    onChangeDirectionByLang(newLang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text: string, options?: Record<string, unknown>) =>
      i18n.t ? i18n.t(text, options) : text,
    currentLang,
    allLangs,
  };
}
